import img from "../../../../../assets/images/profile-sample.jpg";


const ProfileCard = ({ staffData }) => {
  return (
    <div className="flex flex-row justify-between items-center bg-white p-4 rounded-md">
      <div className="flex items-center flex-row gap-4">
        <div className="rounded-full overflow-hidden w-16 h-16">
          <img src={img} alt="profile" />
        </div>
        <span className="flex flex-col gap-0">
          <p className="text-lg font-semibold text-theme">{staffData?.name}</p>
          <p className="text-sm text-textLight">{staffData?.code||staffData?.email} </p>
        </span>
      </div>
    </div>
  );
};

export default ProfileCard;
